<template>
    <div class="dashboard-page" v-if="userRole">
        <DashboardKpis />
        <!-- HERO / ACCESSOS DESTACATS -->
        <!-- <section class="featured-grid">
            <router-link
                v-if="show.campaigns || show.planning"
                to="/dashboard/campaigns"
                class="featured-card featured-card--dark"
            >
                <div class="featured-icon">
                    <i class="mdi mdi-bullhorn-outline"></i>
                </div>

                <div class="featured-content">
                    <span>Acceso destacado</span>
                    <h2>Gestión de campañas</h2>
                    <p>Administra campañas, líneas y seguimiento operativo.</p>
                </div>

                <div class="featured-arrow">
                    <i class="mdi mdi-arrow-right"></i>
                </div>
            </router-link>

            <router-link
                v-if="show.planning"
                to="/dashboard/DescarregarPlaniXls"
                class="featured-card featured-card--pink"
            >
                <div class="featured-icon">
                    <i class="mdi mdi-calendar-check-outline"></i>
                </div>

                <div class="featured-content">
                    <span>Acceso destacado</span>
                    <h2>Planificación</h2>
                    <p>Recarga, valida, descarga y envía la planificación diaria.</p>
                </div>

                <div class="featured-arrow">
                    <i class="mdi mdi-arrow-right"></i>
                </div>
            </router-link>
        </section> -->

        <!-- SECCIONS DEL DASHBOARD -->
        <section class="dashboard-sections">
            <div
                v-for="section in dashboardSections"
                :key="section.key"
                class="dashboard-section"
                :class="{ 'dashboard-section--half': section.half }"
            >
                <div class="section-header">
                    <span>{{ section.label }}</span>
                    <h2>{{ section.title }}</h2>
                </div>

                <div class="section-cards">
                    <component
                        :is="item.href ? 'a' : 'router-link'"
                        v-for="item in section.items"
                        :key="item.title"
                        class="module-card"
                        :to="item.to"
                        :href="item.href"
                        :target="item.href ? '_blank' : null"
                        :rel="item.href ? 'noopener noreferrer' : null"
                    >
                        <div class="module-icon" :class="`module-icon--${item.color}`">
                            <i :class="item.icon"></i>
                        </div>

                        <div class="module-content">
                            <h3>{{ item.title }}</h3>
                            <p>{{ item.description }}</p>
                        </div>

                        <div class="module-arrow">
                            <i class="mdi mdi-chevron-right"></i>
                        </div>
                    </component>
                </div>
            </div>
        </section>

        <!-- IMPERSONACIÓ -->
        <section v-if="show.impersonar" class="dashboard-section">
            <div class="section-header">
                <span>Administración</span>
                <h2>Impersonar usuario</h2>
            </div>

            <div class="section-cards section-cards--compact">
                <button class="module-card module-card--button" @click="showDialog = true">
                    <div class="module-icon module-icon--pink">
                        <i class="mdi mdi-account-switch-outline"></i>
                    </div>

                    <div class="module-content">
                        <h3 v-if="impersonatedUser">Suplantando: {{ impersonatedUser.name }}</h3>
                        <h3 v-else>Escoger usuario</h3>
                        <p>Accede temporalmente con permisos de otro usuario.</p>
                    </div>

                    <div class="module-arrow">
                        <i class="mdi mdi-chevron-right"></i>
                    </div>
                </button>
            </div>
        </section>

        <!-- POPUP PER TRIAR USUARI -->
        <v-dialog v-model="showDialog" max-width="500">
            <v-card>
                <v-card-title>Selecciona un usuari</v-card-title>

                <v-card-text>
                    <v-select
                        v-model="selectedUserId"
                        :items="users"
                        item-title="name"
                        item-value="id"
                        label="Usuari"
                    />
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="showDialog = false">Cancel·lar</v-btn>
                    <v-btn color="primary" @click="startImpersonation">Impersonar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <ImpersonationBanner />
    </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'
import { useAlert } from '@/composables/useAlert'
import { useImpersonation } from '@/composables/useImpersonation'
import DashboardKpis from '@/components/dashboard/DashboardKpis.vue'

const { impersonatedUser } = useImpersonation()

const router = useRouter()
const userRole = ref(null)

const { showAlertMessage } = useAlert()

const showDialog = ref(false)
const selectedUserId = ref(null)
const users = ref([])

const fetchUsers = async () => {
    try {
        const { data } = await axios.get('/api/admin/users', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                withCredentials: true
            }
        })
        users.value = data
    } catch (e) {
        showAlertMessage('Error carregant usuaris', 'error')
    }
}

const startImpersonation = async () => {
    if (!selectedUserId.value) return;

    try {
        const { data } = await axios.post(`/api/impersonate/${selectedUserId.value}`, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                withCredentials: true
            }
        })

        // Substitueix el token
        localStorage.setItem('token', data.token)

        window.location.reload()
    } catch (e) {
        showAlertMessage('Error al iniciar la impersonació', 'error');
    }
}

onMounted(async () => {

    fetchUsers()
    const { data: user } = await axios.get('/api/user', {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            withCredentials: true
        }
    })

    userRole.value = user.role

    if (userRole.value === 'warehouse' &&
        !['/dashboard/stock', '/dashboard/departures'].includes(router.currentRoute.value.path)) {
        router.replace('/dashboard')
    }
})

const show = computed(() => {
    const roles = {
        admin: {
            clients: true,
            providers: true,
            campaigns: true,
            stock: true,
            departures: true,
            warehouses: true,
            warehousesList: true,
            planning:true,
            users: true,
            campaignWeb: true,
            impersonar: true,
            clientInfo: true,
            auditLink: true,
            geoboxLink: true,
            movionLink: true,
            corporateWebLink: true,
            geoserverLink: true,
            ontimeLink: true
        },
        warehouseBCN: {
            clients: false,
            providers: false,
            campaigns: false,
            stock: true,
            departures: true,
            warehouses: false,
            warehousesList: true,
            planning:false,
            users: false,
            campaignWeb: false,
            impersonar: false,
            clientInfo: false,
            auditLink: false,
            geoboxLink: false,
            movionLink: false,
            corporateWebLink: true,
            geoserverLink: false,
            ontimeLink: true
        },
        warehouseMAD: {
            clients: false,
            providers: false,
            campaigns: false,
            stock: false,
            departures: false,
            warehouses: false,
            warehousesList: true,
            planning:false,
            users: false,
            campaignWeb: false,
            impersonar: false,
            clientInfo: false,
            auditLink: false,
            geoboxLink: false,
            movionLink: false,
            corporateWebLink: true,
            geoserverLink: false,
            ontimeLink: true
        },
        production: {
            clients: false,
            providers: false,
            campaigns: true,
            stock: true,
            departures: true,
            warehouses: true,
            warehousesList: true,
            planning: true,
            users: false,
            campaignWeb: false,
            impersonar: false,
            clientInfo: true,
            auditLink: true,
            geoboxLink: false,
            movionLink: true,
            corporateWebLink: true,
            geoserverLink: false,
            ontimeLink: true
        },
        planning: {
            clients: false,
            providers: false,
            campaigns: false,
            stock: false,
            departures: false,
            warehouses: false,
            warehousesList: false,
            planning: true,
            users: false,
            campaignWeb: false,
            impersonar: false,
            clientInfo: false,
            auditLink: true,
            geoboxLink: false,
            movionLink: false,
            corporateWebLink: true,
            geoserverLink: false,
            ontimeLink: true
        },
        comercial: {
            clients: false,
            providers: false,
            campaigns: false,
            stock: false,
            departures: false,
            warehouses: false,
            warehousesList: false,
            planning: false,
            users: false,
            campaignWeb: true,
            impersonar: false,
            clientInfo: false,
            auditLink: true,
            geoboxLink: false,
            movionLink: false,
            corporateWebLink: true,
            geoserverLink: false,
            ontimeLink: false
        },
        backoffice: {
            clients: true,
            providers: false,
            campaigns: false,
            stock: false,
            departures: false,
            warehouses: false,
            warehousesList: false,
            planning: false,
            users: false,
            campaignWeb: true,
            impersonar: false,
            clientInfo: false,
            auditLink: false,
            geoboxLink: true,
            movionLink: true,
            corporateWebLink: true,
            geoserverLink: true,
            ontimeLink: false
        },
        quality: {
            clients: true,
            providers: false,
            campaigns: false,
            stock: false,
            departures: false,
            warehouses: false,
            warehousesList: false,
            planning: false,
            users: false,
            campaignWeb: true,
            impersonar: false,
            clientInfo: false,
            auditLink: true,
            geoboxLink: false,
            movionLink: true,
            corporateWebLink: true,
            geoserverLink: false,
            ontimeLink: false
        },
        gerencia: {
            clients: true,
            providers: true,
            campaigns: true,
            stock: true,
            departures: true,
            warehouses: true,
            warehousesList: true,
            planning: true,
            users: false,
            campaignWeb: true,
            impersonar: true,
            clientInfo: true,
            auditLink: true,
            geoboxLink: true,
            movionLink: true,
            corporateWebLink: true,
            geoserverLink: true,
            ontimeLink: true
        }
    }
    return roles[userRole.value] || {}
})

const dashboardSections = computed(() => {
    const sections = []


    const equiposItems = [
        show.value.campaigns && {
            title: 'Gestión de campañas',
            description: 'Administra campañas, líneas y seguimiento operativo.',
            to: '/dashboard/campaigns',
            icon: 'mdi mdi-bullhorn-outline',
            color: 'blue'
        },
        show.value.warehouses && {
            title: 'Almacenes',
            description: 'Control de almacenes y referencias logísticas.',
            to: '/dashboard/warehouses',
            icon: 'mdi mdi-warehouse',
            color: 'blue'
        },
        show.value.stock && {
            title: 'Stocks',
            description: 'Consulta existencias y movimientos disponibles.',
            to: '/dashboard/stock',
            icon: 'mdi mdi-archive-outline',
            color: 'blue'
        },
        show.value.departures && {
            title: 'Salidas',
            description: 'Gestión de salidas de almacén.',
            to: '/dashboard/departures',
            icon: 'mdi mdi-truck-delivery-outline',
            color: 'blue'
        }
    ].filter(Boolean)

    if (equiposItems.length) {
        sections.push({
            key: 'equipos',
            label: 'Almacenes',
            title: 'Gestión de almacenes',
            items: equiposItems
        })
    }

    const almacenesItems = [
        show.value.warehousesList && {
            title: 'Carga equipos',
            description: 'Consulta la carga diaria agrupada por equipo.',
            to: '/dashboard/warehousesLists',
            icon: 'mdi mdi-forklift',
            color: 'orange'
        },
        show.value.warehousesList && {
            title: 'Albaranes ET',
            description: 'Genera albaranes de entrega en tienda.',
            to: '/dashboard/AlbaransEntrega',
            icon: 'mdi mdi-file-sign',
            color: 'orange'
        },
        show.value.warehousesList && {
            title: 'Rexpediciones',
            description: 'Gestión y consulta de reexpediciones.',
            to: '/dashboard/warehousesListsRex',
            icon: 'mdi mdi-truck-fast-outline',
            color: 'orange'
        },
        show.value.warehousesList && {
            title: 'Rexpedicione Híbridos',
            description: 'Gestión y consulta de reexpediciones.',
            to: '/dashboard/MagatzemsRexpedicioHibrid',
            icon: 'mdi mdi-truck-snowflake',
            color: 'orange'
        }
    ].filter(Boolean)

    if (almacenesItems.length) {
        sections.push({
            key: 'almacenes-listados',
            label: 'Almacenes',
            title: 'Listados y documentación',
            items: almacenesItems
        })
    }

    const planificacionItems = [
        show.value.planning && {
            title: 'Recargar planificación',
            description: 'Actualiza datos de planificación desde origen.',
            to: '/dashboard/ReloadPlani',
            icon: 'mdi mdi-autorenew',
            color: 'purple'
        },
        show.value.planning && {
            title: 'Validar planificación',
            description: 'Ejecuta validaciones operativas de planificación.',
            to: '/dashboard/ValidarPlani',
            icon: 'mdi mdi-check-decagram-outline',
            color: 'purple'
        },
        show.value.warehousesList && {
            title: 'Descargar planimetría',
            description: 'Exporta la planificación en formato CSV/XLS.',
            to: '/dashboard/DescarregarPlaniXls',
            icon: 'mdi mdi-file-download-outline',
            color: 'purple'
        },
        show.value.warehousesList && {
            title: 'Enviar planimetría',
            description: 'Envía la planificación diaria a los equipos.',
            to: '/dashboard/EnviarPlani',
            icon: 'mdi mdi-send-outline',
            color: 'purple'
        },
        show.value.warehousesList && {
            title: 'Planificador IA',
            description: 'Acceso externo al planificador inteligente.',
            href: 'http://planificador.traycco.com/',
            icon: 'mdi mdi-robot-excited-outline',
            color: 'purple'
        }
    ].filter(Boolean)

    if (planificacionItems.length) {
        sections.push({
            key: 'planificacion',
            label: 'Planificación',
            title: 'Herramientas operativas',
            half: true,
            items: planificacionItems
        })
    }

    const produccionItems = [
        show.value.planning && {
            title: 'Campañas iniciadas sin planificar',
            description: 'Consulta campañas ya iniciadas que todavía no tienen planificación.',
            to: '/dashboard/CampanyasIniciadasSinPlanificar',
            icon: 'mdi mdi-calendar-alert-outline',
            color: 'red'
        },
        show.value.planning && {
            title: 'Entregas en tienda',
            description: 'Seguimiento operativo de entregas en tienda.',
            to: '/dashboard/EntregasTienda',
            icon: 'mdi mdi-store-check-outline',
            color: 'red'
        },
        show.value.planning && {
            title: 'Repartos de hoy',
            description: 'Consulta rápida de los repartos previstos para hoy.',
            to: '/dashboard/RepartosHoy',
            icon: 'mdi mdi-truck-delivery-outline',
            color: 'red'
        },
        show.value.planning && {
            title: 'Web Proveedor',
            description: 'Acceso externo a la web de proveedor.',
            href: 'https://traycco.com/ProveedorV2/index.html#/',
            icon: 'mdi mdi-robot-excited-outline',
            color: 'purple'
        }
    ].filter(Boolean)

    if (produccionItems.length) {
        sections.push({
            key: 'produccion',
            label: 'Producción',
            title: 'Seguimiento operativo',
            half: true,
            items: produccionItems
        })
    }

    const clientesItems = [
        show.value.clients && {
            title: 'Clientes',
            description: 'Alta, consulta y mantenimiento de clientes.',
            to: '/dashboard/clients',
            icon: 'mdi mdi-office-building-outline',
            color: 'green'
        },
        show.value.campaignWeb && {
            title: 'Campañas web cliente',
            description: 'Gestión de campañas visibles en la web de cliente.',
            to: '/dashboard/CampaignWebList',
            icon: 'mdi mdi-text-box-multiple-outline',
            color: 'green'
        },
        show.value.campaignWeb && {
            title: 'Estudios Geomarketing',
            description: 'Documentación y estudios asociados al cliente.',
            to: '/dashboard/Documentacio/1',
            icon: 'mdi mdi-map-search-outline',
            color: 'green'
        },
        show.value.campaignWeb && {
            title: 'Documentación Calidad',
            description: 'Documentos de calidad disponibles para clientes.',
            to: '/dashboard/Documentacio/2',
            icon: 'mdi mdi-file-document-check-outline',
            color: 'green'
        }
    ].filter(Boolean)

    if (clientesItems.length) {
        sections.push({
            key: 'clientes',
            label: 'Clientes',
            title: 'Gestión comercial',
            //half: true,
            items: clientesItems
        })
    }

    if (['admin', 'gerencia', 'backoffice'].includes(userRole.value)) {
        sections.push({
            key: 'clientes-web',
            label: 'Clientes',
            title: 'Gestión de clientes web',
            items: [{
                title: 'Pedidos clientes web',
                description: 'Accede al apartado de pedidos de clientes web.',
                to: '/dashboard/pedidos-clientes-web',
                icon: 'mdi mdi-cart-outline',
                color: 'green'
            }, {
                title: 'Leads',
                description: 'Registra y edita el total mensual de leads.',
                to: '/dashboard/leads',
                icon: 'mdi mdi-account-plus-outline',
                color: 'green'
            }, {
                title: 'Inversión SEO + ADS',
                description: 'Registra y edita la inversión mensual en SEO y ADS.',
                to: '/dashboard/inversion-seo-ads',
                icon: 'mdi mdi-chart-line',
                color: 'green'
            }]
        })
    }

    if (['admin', 'compres'].includes(userRole.value)) {
        sections.push({
            key: 'compres',
            label: 'Gestió',
            title: 'Compres',
            items: [{
                title: 'Llistat de compres',
                description: 'Consulta quantitats, triples i costos de les línies RX.',
                to: '/dashboard/compres',
                icon: 'mdi mdi-cart-outline',
                color: 'orange'
            }]
        })
    }

    const enlacesItems = [
        ['admin', 'comercial'].includes(userRole.value) && {
            title: 'Landings',
            description: 'Accede al inicio de sesión de la plataforma de landings.',
            href: 'https://landing.apuntopdv.com/',
            icon: 'mdi mdi-web',
            color: 'blue'
        },
        show.value.auditLink && {
            title: 'AUDIT',
            description: 'Acceso externo al sistema de auditoría.',
            href: 'https://traycco.com/Audit4Front/index.html',
            icon: 'mdi mdi-clipboard-check-outline',
            color: 'blue'
        },
        show.value.geoboxLink && {
            title: 'Experian',
            description: 'Herramienta externa de gestión geográfica.',
            href: 'https://login.axesor.es',
            icon: 'mdi mdi-map-marker-radius-outline',
            color: 'blue'
        },
        show.value.movionLink && {
            title: 'Movion',
            description: 'Acceso externo para producción y operativa.',
            href: 'https://track.mitecmobilegps.com/#/',
            icon: 'mdi mdi-routes',
            color: 'blue'
        },
        show.value.geoserverLink && {
            title: 'Geoserver',
            description: 'Servidor de capas y servicios geográficos.',
            href: 'https://geoserver.traycco.com/geoserver/web/',
            icon: 'mdi mdi-layers-triple-outline',
            color: 'blue'
        },
        show.value.ontimeLink && {
            title: 'Ontime',
            description: 'Transportes',
            href: 'https://ontimegts.alertran.net/gts/login.seam?cid=9454',
            icon: 'mdi mdi-truck-delivery-outline',
            color: 'blue'
        },
        show.value.corporateWebLink && {
            title: 'Web corporativa',
            description: 'Página web de Traycco.',
            href: 'https://www.traycco.es',
            icon: 'mdi mdi-web',
            color: 'blue'
        }
    ].filter(Boolean)

    if (enlacesItems.length) {
        sections.push({
            key: 'enlaces',
            label: 'Enlaces',
            title: 'Webs externas',
            items: enlacesItems
        })
    }

    const adminItems = [
        show.value.providers && {
            title: 'Proveedores',
            description: 'Consulta y administra proveedores operativos.',
            to: '/dashboard/providers',
            icon: 'mdi mdi-truck-outline',
            color: 'pink'
        },
        show.value.users && {
            title: 'Usuarios',
            description: 'Gestiona accesos, roles y permisos.',
            to: '/dashboard/users',
            icon: 'mdi mdi-account-group-outline',
            color: 'pink'
        },
        show.value.users && {
            title: 'Mailing',
            description: 'Gestión de envíos y comunicaciones.',
            to: '/dashboard/mailing',
            icon: 'mdi mdi-email-fast-outline',
            color: 'pink'
        },
        show.value.users && {
            title: 'Estadísticas',
            description: 'Consulta métricas y gráficos generales.',
            to: '/dashboard/statistics',
            icon: 'mdi mdi-chart-line',
            color: 'pink'
        },
        show.value.clientInfo && {
            title: 'Información de clientes',
            description: 'Consulta información ampliada de clientes.',
            to: '/dashboard/client_info',
            icon: 'mdi mdi-account-details-outline',
            color: 'pink'
        }
    ].filter(Boolean)

    if (adminItems.length) {
        sections.push({
            key: 'administracion',
            label: 'Administración',
            title: 'Configuración global',
            items: adminItems
        })
    }

    return sections
})

</script>

<style scoped>
.dashboard-page {
    min-height: calc(100vh - 120px);
    padding: 24px;
    background:
        radial-gradient(circle at top right, rgba(118, 44, 69, 0.08), transparent 32%),
        #f5f6f8;
}

/* ACCESSOS DESTACATS */

.featured-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
    margin-bottom: 22px;
}

.featured-card {
    position: relative;
    min-height: 150px;
    display: flex;
    align-items: center;
    gap: 18px;
    overflow: hidden;
    padding: 28px;
    border-radius: 20px;
    color: #ffffff;
    text-decoration: none;
    box-shadow: 0 14px 34px rgba(20, 20, 20, 0.12);
    transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.featured-card::after {
    content: "";
    position: absolute;
    width: 210px;
    height: 210px;
    right: 18%;
    top: -70px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.13);
}

.featured-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 20px 42px rgba(20, 20, 20, 0.16);
}

.featured-card--dark {
    background: linear-gradient(135deg, #641436, #9e4165);
}

.featured-card--pink {
    background: linear-gradient(135deg, #7b173d, #c82f78);
}

.featured-icon {
    width: 62px;
    height: 62px;
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.14);
    font-size: 30px;
    z-index: 1;
}

.featured-content {
    z-index: 1;
}

.featured-content span {
    display: block;
    margin-bottom: 7px;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.78);
}

.featured-content h2 {
    margin: 0 0 6px;
    font-size: 1.45rem;
    font-weight: 800;
    line-height: 1.15;
}

.featured-content p {
    margin: 0;
    font-size: 0.92rem;
    color: rgba(255, 255, 255, 0.86);
}

.featured-arrow {
    width: 42px;
    height: 42px;
    display: grid;
    place-items: center;
    margin-left: auto;
    flex: 0 0 auto;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.18);
    font-size: 24px;
    z-index: 1;
}

/* SECCIONS */

.dashboard-sections {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
}

.dashboard-section {
    padding: 24px;
    border: 1px solid rgba(15, 23, 42, 0.06);
    border-radius: 20px;
    background: #ffffff;
    box-shadow: 0 8px 26px rgba(15, 23, 42, 0.05);
}

.dashboard-section:not(.dashboard-section--half) {
    grid-column: 1 / -1;
}

.section-header {
    margin-bottom: 18px;
}

.section-header span {
    display: block;
    margin-bottom: 6px;
    color: #a04b68;
    font-size: 0.72rem;
    font-weight: 900;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.section-header h2 {
    margin: 0;
    color: #102333;
    font-size: 1.25rem;
    font-weight: 800;
}

.section-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 14px;
}

.section-cards--compact {
    grid-template-columns: repeat(auto-fit, minmax(320px, 420px));
}

/* MINI CARDS */

.module-card {
    min-height: 96px;
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 16px;
    background: linear-gradient(180deg, #ffffff, #fbfbfc);
    color: #102333;
    text-decoration: none;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
    transition:
        transform 0.16s ease,
        box-shadow 0.16s ease,
        border-color 0.16s ease,
        background-color 0.16s ease;
}

.module-card:hover {
    transform: translateY(-2px);
    border-color: rgba(118, 44, 69, 0.22);
    box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.module-card--button {
    width: 100%;
    border: 1px solid rgba(15, 23, 42, 0.08);
    cursor: pointer;
    text-align: left;
    font-family: inherit;
}

.module-icon {
    width: 46px;
    height: 46px;
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    border-radius: 13px;
    font-size: 25px;
}

.module-icon--blue {
    color: #2563eb;
    background: #eaf2ff;
}

.module-icon--orange {
    color: #c46a14;
    background: #fff1dc;
}

.module-icon--green {
    color: #16875d;
    background: #e7f8ef;
}

.module-icon--purple {
    color: #6d3fd3;
    background: #f0e9ff;
}

.module-icon--pink {
    color: #a42558;
    background: #fde8f2;
}

.module-icon--red {
    color: #dc2626;
    background: #fee2e2;
}

.module-icon--teal {
    color: #0f766e;
    background: #ccfbf1;
}

.module-icon--gray {
    color: #475569;
    background: #f1f5f9;
}

.module-content {
    min-width: 0;
}

.module-content h3 {
    margin: 0 0 5px;
    color: #172b3a;
    font-size: 0.96rem;
    font-weight: 800;
}

.module-content p {
    margin: 0;
    color: #6b7b88;
    font-size: 0.82rem;
    line-height: 1.35;
}

.module-arrow {
    margin-left: auto;
    color: #8aa0af;
    font-size: 22px;
}

/* RESPONSIVE */

@media (max-width: 1200px) {
    .dashboard-sections {
        grid-template-columns: 1fr;
    }

    .dashboard-section,
    .dashboard-section:not(.dashboard-section--half) {
        grid-column: auto;
    }
}

@media (max-width: 820px) {
    .dashboard-page {
        padding: 14px;
    }

    .featured-grid {
        grid-template-columns: 1fr;
    }

    .featured-card {
        min-height: auto;
        padding: 22px;
    }

    .featured-card::after {
        right: -70px;
    }

    .section-cards {
        grid-template-columns: 1fr;
    }
}
</style>
